const FIONA_VENMO = 'fionayue'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const VENMO_URL = `https://venmo.com/${FIONA_VENMO}`

// This could be used in the future for a public payment link.
const PUBLIC_PAYMENT_LINK = `https://venmo.com/?txn=pay&audience=public&recipients=fionayue&note=Registry`

export default function RegistryRoute() {
	return (
		<main className="container py-10 pt-20 sm:py-6">
			<h1 className="mb-3 text-4xl md:text-6xl">Registry</h1>
			<h2 className="text-xl capitalize md:text-3xl">
				the presence of our friends and family is the greatest gift of all.
			</h2>

			<hr className="my-4" />

			{/* @TODO: Make venmo user name clickable link to Venmo */}
			<h2 className="text-xl md:text-3xl">
				BUT if you would like to bless us with a gift, we would really
				appreciate a fun and memorable honeymoon! If you would like to
				contribute, feel free to Venmo{' '}
				<a href={PUBLIC_PAYMENT_LINK} target="_blank" rel="noreferrer">
					<strong>@{FIONA_VENMO}</strong>
				</a>
			</h2>

			{/* @TODO: Make venmo user name clickable link to Venmo */}
			<div className="flex justify-center">
				<img src="/img/venmo.png" className="w-1/2" alt="Fiona's venmo code" />
			</div>
		</main>
	)
}
